// 3D Model constants for DFN/WSON packages
export const dfnPinMarkerSize = 0.00025; // Smaller for compact DFN packages
export const dfnPinMarkerOffset = (packageSizeX, packageSizeY) => (Math.log10(10 + Math.min(packageSizeX, packageSizeY) * 5000) - 1) / 550;
export const dfnPinMarkerOffsetZ = 0.000001;
export const dfnPinMarkerSegments = 32;
//# sourceMappingURL=dfnConstants.js.map